// Module
var code = `<div class="side_bar{{#.visibleSidePanel}} active{{/}}{{isCollapsed ? ' collapsed' : ''}}" name="side_bar" style="{{>visibility}}" on-mousedown="@this.onMouseDown(event)">
    <div class="side_bar_btn_container">
        <div class="side_bar_top">
            <alertsButton name="alerts" 
                additionalClass="{{.topButtonAdditionalClass}}" 
                visible="{{.alertsBtnVisible}}" 
                enabled="true" 
                on-componentClick="alertClick"
                checked="{{activeSidePanel === PanelNames.AlertPanel}}" />
            <notificationsButton name="notificationsBtn" 
                additionalClass="{{.topButtonAdditionalClass}}" 
                counterStyle="js-blinkingCounter" 
                visible="{{.notificationsBtnVisible}}" 
                enabled="true" 
                on-componentClick="notificationsClick" 
                checked="{{activeSidePanel === PanelNames.NotificationsPanel}}"/>
            <videoWidgetButton name="videoWidgetBtn" 
                additionalClass="{{.topButtonAdditionalClass}}" 
                terceraButtonStyle="js-button-video-widget" 
                visible="{{.videoWidgetBtnVisible}}" 
                enabled="true" 
                on-componentClick="videoWidgetBtnClick" 
                checked="{{activeSidePanel === PanelNames.VideoWidget}}"/>
        </div>

        <div class="side_bar_bottom">
            {{#if showQRCodeButton}}
                <reactTooltipDecorator content="{{qrCodeButtonTooltip}}">
                    <reactIconButton 
                        icon="{{qrCodeButtonIcon}}" 
                        mode="{{qrCodeButtonMode}}"
                        selected="{{qrCodeButtonSelected}}"
                        on-onClick="@this.onQRCodeButtonClick(\$1)"/>
                </reactTooltipDecorator>
            {{/if}}
            <terceraSideBarButton name="help" 
                enabled="true" 
                on-componentClick="helpClick" 
                visible="{{.isHelpVisible}}" 
                tooltip="{{.helpTooltip}}" />
            <terceraSideBarButton name="sideBarSettings" 
                enabled="{{.connectedStatus}}" 
                tooltip="{{.connectedStatus ? .settingsTooltip : localizedSettingsDisabledTT}}" 
                on-componentClick="settingsClick"
                checked="{{isGeneralSettingsOpened}}"/>
            <terceraSideBarButton name="logout" 
                enabled="true" 
                on-componentClick="disconnectClick" 
                tooltip="{{.logoutTooltip}}"/>
        </div>
    </div>

    {{#if .visibleSidePanel}}
        <div class="side_bar_panel_container" id="sideBarPanelContainer">
            <dropDownSideBar activeSidePanel="{{.activeSidePanel}}" SideBarPanelRef="{{.SideBarPanelRef}}"/>
        </div>
    {{else}}
        <terceraButton 
            name="ArrowLeft" 
            SVG="true"
            terceraButtonStyle="side-bar-collapsed-btn{{isCollapsed ? ' active' : ''}}" 
            on-btnClick="collapseButtonClick"
            tooltip="{{isCollapsed ? showSideBarTooltip : hideSideBarTooltip}}"/>
    {{/if}}
</div>`;
// Exports
export default code;